import BaseModel from './BaseModel';

export default class Partner extends BaseModel {

}
